import { render } from "./LayoutSingle.vue?vue&type=template&id=13ca0cbf&scoped=true"
import script from "./LayoutSingle.vue?vue&type=script&lang=js"
export * from "./LayoutSingle.vue?vue&type=script&lang=js"

import "./LayoutSingle.vue?vue&type=style&index=0&id=13ca0cbf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ca0cbf"]])

export default __exports__